import { render, staticRenderFns } from "./WorkspaceScalesPage.vue?vue&type=template&id=355b2af5&scoped=true"
import script from "./WorkspaceScalesPage.vue?vue&type=script&lang=ts"
export * from "./WorkspaceScalesPage.vue?vue&type=script&lang=ts"
import style0 from "./WorkspaceScalesPage.vue?vue&type=style&index=0&id=355b2af5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355b2af5",
  null
  
)

export default component.exports